import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-home-page-root',
  templateUrl: './home-page-root.component.html',
  styles: []
})
export class HomePageRootComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}



// WEBPACK FOOTER //
// /opt/app/develop/src/app/pages/home/home-page-root.component.ts